<template>
  <div class="bottom">
    <el-row :gutter="20">
      <div class="desktop-layout">
        <el-col :xs="0" :sm="0" :md="0" :lg="6" :xl="6">
        <div>
          <el-image class="bottom-logo" :fit="'fill'" :src="logoUrl" alt="logo" />
        </div>
      </el-col>
      </div>
      <el-col :xs="16" :sm="16" :md="16" :lg="12" :xl="12">
        <h3>{{claim[0]}}</h3>
        <p class="bottom-contact">
          {{claim[1]}}<br>
          {{claim[2]}}<br>
          {{claim[3]}}
        </p>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="6">
        <h4>{{claim[4]}}</h4>
        <div>
          <el-image class="bottom-payment" :src="urlWechatPay" fit="fill" /> 
          <el-image class="bottom-payment" :src="urlAlipay" fit="fill" /> 
          <el-image class="bottom-payment" :src="urlUnionPay" fit="fill" />
        </div>
        <p class="bottom-terms">
          <a href="/policy/terms-of-service.html">{{claim[5]}}</a>&nbsp;&nbsp;&nbsp;&nbsp;
          <a href="/policy/privacy-policy.html">{{claim[6]}}</a>&nbsp;&nbsp;&nbsp;&nbsp;
        </p>
      </el-col>
    </el-row>
    <el-divider />
    <div class="bottom-claim">
      <p>
        <span>
          闽ICP备2025112670号 
          | <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35010202002047" rel="noreferrer" target="_blank"><el-avatar :src="gaUrl" :size="15" /> 闽公网安备35010202002047号</a>
        </span>
      </p>
      <p>
        <span>{{claim[7]}}©2025-{{thisYear}} {{claim[0]}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
      </p>
    </div>
  </div>
</template>


<script>
import { Store } from '@/utils/store'
import { Lang } from '@/utils/language'
export default {
  name: 'BottomClaim',
  props: {
    logo: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      urlWechatPay: require('@/assets/payment/wechatpay.png'),
      urlAlipay: require('@/assets/payment/alipay.png'),
      urlUnionPay: require('@/assets/payment/unionpay.png'),
      gaUrl: require('@/assets/ga.png'),
      logoUrl: this.logo,
      thisYear: Store.thisYear,
    }
  },
  computed: {
    claim() {
      if (Store.lang == 'en') {
        Store.changeLang('en');
        return Lang.Claim.en;
      } else {
        Store.changeLang('cn');
        return Lang.Claim.cn;
      }
    },
  },  
}
</script>


<style lang="scss" scoped>
@import '@/assets/variables.scss';
h3 {
  color: white;
}
a {  
  text-decoration: none;
  color: #FFFFFFB2;
}
.bottom {
  z-index: 1;
  width: auto;
  min-height: $bottom-height;
  background-color: $bottom-color;
  color: #FFFFFFB2;
  font-family: Poppins;
  font-size: 1em;
  text-align: left;
}
.bottom-logo {
  margin-top: 20px;
  width:128px; 
  height:128px;
}
.bottom-contact, .bottom-terms {
  font-size: 0.9em;
}
.bottom-payment {
  padding: 0 5px;
  width:80px; 
}
.bottom-claim {
  font-size: 0.8em;
  text-align: center;
}
/* 设置了浏览器宽度不小于1201px时 list显示的宽度 */
@media screen and (min-width: 1080px) {
  .desktop-layout {
    display: block;
  }
  .mobile-layout {
    display: none;
  }
  .bottom {
    padding: 20px 10%;
  }
}
@media screen and (max-width: 1080px) and (orientation: portrait) {
  .desktop-layout {
    display: none;
  }
  .mobile-layout {
    display: block;
  }  
  .bottom {
    padding: 1px 5%;
  }
}
</style>